import React from 'react'
import './Learn_ai.css'

const Learn_ai = () => {
    const unviersityLogo = [
        { image: '/assets/images/home/learn-ai/university/2.png' },
        { image: '/assets/images/home/learn-ai/university/1.png' },
        { image: '/assets/images/home/learn-ai/university/4.png' },
        { image: '/assets/images/home/learn-ai/university/3.png' },
        { image: '/assets/images/home/learn-ai/university/6.png' },
        { image: '/assets/images/home/learn-ai/university/5.png' },
    ];

    const partnerslogo = [
        {image:'/assets/images/home/learn-ai/partners/1.png'},
        {image:'/assets/images/home/learn-ai/partners/2.png'},
        {image:'/assets/images/home/learn-ai/partners/3.png'},
        {image:'/assets/images/home/learn-ai/partners/4.png'},
        {image:'/assets/images/home/learn-ai/partners/5.png'},
        {image:'/assets/images/home/learn-ai/partners/6.png'},
        {image:'/assets/images/home/learn-ai/partners/7.png'},
        {image:'/assets/images/home/learn-ai/partners/8.png'},
        {image:'/assets/images/home/learn-ai/partners/9.png'},
        {image:'/assets/images/home/learn-ai/partners/10.png'},
        {image:'/assets/images/home/learn-ai/partners/11.png'},        
    ]



    return (
        <>
            <div className='container-lg'>
                <section className='learn_ai_sec'>
                    <div className='flex_sec'>

                        <div className='firstsec'>
                            <div className='innersec'>
                                <div className='innerdata'>
                                    <p className='upgradep'>Upgrade Your Skills With a Degree From</p>
                                    <div className='row'>
                                        {unviersityLogo.map((data, index) => (
                                            <div className='col-6 mb-2'>
                                                <img className='unlogo' src={process.env.PUBLIC_URL + data.image} />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='midsec'>
                            <div className='img-div'>
                                <img className='mid_img' src={process.env.PUBLIC_URL + '/assets/images/home/learn-ai/bg.png'} />
                            </div>
                        </div>
                        <div className='lastsec'>
                            <div className='innersec'>
                                <div className='innerdata'>
                                    <p className='upgradep'>Upgrade Your Skills With a Degree From</p>
                                    <div className='row'>
                                        {partnerslogo.map((data, index) => (
                                            <div className='col-4 mb-2'>
                                                <img className='unlogo' src={process.env.PUBLIC_URL + data.image} />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}

export default Learn_ai